import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // ip:'http://106.53.145.178:3000'
    //ip:'https://a.gxtkd.org.cn/api'
     ip:'https://images.gxtkd.org.cn'
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
